var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeMin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 21,
    viewBox: "0 -6 21 21",
    width: 21,
    className: "injected-svg",
    "data-src": "/static/media/volume_low.b33e70b7.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f3a952"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.66233 1.66753c-.13273.14653-.31371.229-.50255.229h-.6728c-.84724 0-1.68846.15532-2.48852.45947-1.52847.58107-2.640776 2.03112-2.895599 3.77485l-.0068505.04687c-.1280141.87599-.1280139 1.76857.0000003 2.64456l.0068502.04687c.254823 1.74375 1.367129 3.19375 2.895599 3.77485.80006.3041 1.64128.4595 2.48852.4595h.6728c.18884 0 .36982.0824.50255.229l.4937.545c1.90227 2.1002 5.17917 1.1068 5.81537-1.7629.6723-3.0327.6723-6.1965 0-9.22917-.6362-2.8697401-3.9131-3.863145-5.81537-1.76297z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMin);
export default __webpack_public_path__ + "static/media/volume-min.a5ab4b222ec975d1b3827c52a0ae040c.svg";
export { ForwardRef as ReactComponent };